import { generateRandomId } from '@/utils/generateRandomId'

export const goals = [
  {
    id: generateRandomId(),
    name: 'Engagement Ring',
    emoji: '💍',
  },
  {
    id: generateRandomId(),
    name: 'Flight Ticket',
    emoji: '✈️',
  },
  {
    id: generateRandomId(),
    name: 'Car',
    emoji: '🚙',
  },
  {
    id: generateRandomId(),
    name: 'World Travel',
    emoji: '🌍',
  },
  {
    id: generateRandomId(),
    name: 'Beach House',
    emoji: '🏝',
  },
  {
    id: generateRandomId(),
    name: 'New Home',
    emoji: '🏡',
  },
  {
    id: generateRandomId(),
    name: 'Headphones',
    emoji: '🎧',
  },
  {
    id: generateRandomId(),
    name: 'Pickup Truck',
    emoji: '🛻',
  },
  {
    id: generateRandomId(),
    name: 'Baby Essentials',
    emoji: '🍼',
  },
  {
    id: generateRandomId(),
    name: 'Furniture',
    emoji: '🛋',
  },
  {
    id: generateRandomId(),
    name: 'Healthcare',
    emoji: '💊',
  },
  {
    id: generateRandomId(),
    name: 'Birthday Party',
    emoji: '🎂',
  },
  {
    id: generateRandomId(),
    name: 'Motorbike',
    emoji: '🛵',
  },
  {
    id: generateRandomId(),
    name: 'New Phone',
    emoji: '📱',
  },
  {
    id: generateRandomId(),
    name: 'Laptop',
    emoji: '💻',
  },
  {
    id: generateRandomId(),
    name: 'Musical Keyboard',
    emoji: '🎹',
  },
  {
    id: generateRandomId(),
    name: 'Toys',
    emoji: '🧸',
  },
  {
    id: generateRandomId(),
    name: 'Beauty & Self-care',
    emoji: '💅',
  },
  {
    id: generateRandomId(),
    name: 'Fishing Gear',
    emoji: '🎣',
  },
  {
    id: generateRandomId(),
    name: 'Golf',
    emoji: '⛳',
  },
  {
    id: generateRandomId(),
    name: 'Helicopter Ride',
    emoji: '🚁',
  },
  {
    id: generateRandomId(),
    name: 'Boat',
    emoji: '⛵',
  },
  {
    id: generateRandomId(),
    name: 'Gaming Console',
    emoji: '🎮',
  },
  {
    id: generateRandomId(),
    name: 'Ski Trip',
    emoji: '🎿',
  },
  {
    id: generateRandomId(),
    name: 'Graduation',
    emoji: '🎓',
  },
  {
    id: generateRandomId(),
    name: 'Guitar',
    emoji: '🎸',
  },
]

export type Goal = (typeof goals)[0]
